document.addEventListener('DOMContentLoaded', function() {
          var splideElemMain = document.querySelector('#main-slider');
          var immediateImages = document.querySelector('.mm-immediate-images');

          // Initialiser Splide en arrière-plan
          if (splideElemMain) {
            // Précharger les images de Splide
            var preloadImages = function() {
              var main = new Splide(splideElemMain, {
                  type: 'slide',
                  rewind: true,
                  pagination: false,
                  arrows: false,
                  breakpoints: {
                      768: {
                          arrows: false,
                          pagination: false,
                          gap: 8,
                          perMove: 1,
                          height: 270,
                          perPage: 1,
                          padding: {
                            left: 8,
                            right: 8
                        },
                      }
                  }
              });

              // Une fois Splide initialisé, on fait la transition
              main.on('mounted', function() {
                if (immediateImages) {
                  immediateImages.style.opacity = '0';
                  immediateImages.style.visibility = 'hidden';
                  immediateImages.style.position = 'absolute';
                  immediateImages.style.pointerEvents = 'none';
                }
                splideElemMain.classList.remove('mm-hidden');
              });

              main.mount();
            };

            // Démarrer le préchargement immédiatement
            requestIdleCallback ? requestIdleCallback(preloadImages) : setTimeout(preloadImages, 0);
          }
      });





// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
var derniere_position_de_scroll_connue = 0;
var ticking = false;
var CTA = document.querySelector('.mm-cta-sticky');

function mmCtaSticky(position_scroll) {
  if (position_scroll > 800) {
    CTA.classList.add('mm-sticky');
    CTA.style.background = "white";
    CTA.style.maxWidth = "none";
    CTA.style.width = "100vw";
    CTA.style.paddingTop = "12px";
  } else {
    CTA.classList.remove('mm-sticky');
    CTA.style.maxWidth = "none";
    CTA.style.width = "auto";
    CTA.style.paddingLeft = "0%";
    CTA.style.paddingRight = "0%";
  }
}

window.addEventListener('scroll', function(e) {
  derniere_position_de_scroll_connue = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(function() {
      mmCtaSticky(derniere_position_de_scroll_connue);
      ticking = false;
    });
  }
});


// POPUP MODAL
  //  Valider ajout panier
    // ouvrir la popup
    function mmOpenAddProductPopup() {
      document.querySelector('.mm-modal-add-checkout').classList.add('mm-modal-is-open');
      document.querySelector('html').classList.add('stop-scrolling');
     // Fermer après 4 secondes
     setTimeout(function() {
      mmCloseAddProductPopup();
      }, 3000);
    }
    // fermer la popup
    function mmCloseAddProductPopup() {
      document.querySelector('.mm-modal-add-checkout').classList.remove('mm-modal-is-open');
      document.querySelector('html').classList.remove('stop-scrolling');
    }
    //  Modal
    // Ouvrir la modale
    // function mmOpenModal() {
    // 		document.querySelector('.mm-surface-modale').classList.add('mm-modal-is-open');
    // 		document.querySelector('html').classList.add('stop-scrolling');
    // 	}
    //   // Fermer la modal
    // 	function mmCloseModal() {
    // 		document.querySelector('.mm-surface-modale').classList.remove('mm-modal-is-open');
    // 		document.querySelector('html').classList.remove('stop-scrolling');
    // 	}
       //  Modal Sample
      // Ouvrir la modale
      function mmOpenModalSample() {
        document.querySelector('.mm-surface-modale').classList.add('mm-modal-is-open');
        document.querySelector('html').classList.add('stop-scrolling');
      }
      // Fermer la modal
      function mmCloseModalSample() {
        document.querySelector('.mm-surface-modale').classList.remove('mm-modal-is-open');
        document.querySelector('html').classList.remove('stop-scrolling');
      }

// Selector sample MOBILE
document.addEventListener('DOMContentLoaded', function () {
    const sampleMainLink = document.querySelector('.mm-sample-item-main');
    const dropdown = document.querySelector('.mm-sample-dropdown');

    const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

    if (isMobile() && sampleMainLink && dropdown) {
      // Prevent redirect on main sample item
      sampleMainLink.addEventListener('click', function (e) {
        e.preventDefault(); // Block redirection
        dropdown.classList.toggle('is-visible');
      });
      document.addEventListener('click', function (e) {
        if (!sampleMainLink.contains(e.target) && !dropdown.contains(e.target)) {
          dropdown.classList.remove('is-visible');
        }
      });
    }
  });


// POPUP MEDIAS IMAGE
function mmToggleZoomProductMedias(popupContainer) {
  popupContainer.classList.toggle('mm-none');
}

// function initSplidePopupMedias() {
//   var splideElem = document.querySelector(".mm-product-medias-popup-slider");
//   var splideElemThumbnails = document.querySelector('#thumbnail-slider-pop');

//   var main = new Splide(splideElem, {
//       type: "loop",
//       arrows: true,
//       pagination: false,
//       perPage: 1,
//       width: '80%',
//       height: '40%',
//       breakpoints: {
//           768: {
//               arrows: false,
//               pagination: true,
//               width: '60%',
//           },
//       },
//   });

//   var thumbnails = new Splide(splideElemThumbnails, {
//       type: 'slide',
//       height: 90,
//       gap: 16,
//       fixedWidth: 100,
//       fixedHeight: 100,
//       direction: 'ltr',
//       isNavigation: true,
//       pagination: false,
//       arrows: true,
//       breakpoints: {
//           768: {
//               direction: 'ltr',
//               fixedHeight: 50,
//               fixedWidth: 50,
//               perPage: 1,
//           }
//       },
//   });

//   main.sync(thumbnails);
//   main.mount();
//   thumbnails.mount();

//   var productMedias = document.querySelectorAll(".mm-product-medias .mm-pm-img-container");
//   productMedias.forEach(function (productMedia) {
//       productMedia.addEventListener("click", function () {
//           var popupContainer = document.querySelector('.mm-product-medias-popup-container');
//           mmToggleZoomProductMedias(popupContainer);
//           var index = parseInt(productMedia.dataset.index);
//           main.go(index);
//       });
//   });
// }

// document.addEventListener("DOMContentLoaded", function () {
//   initSplidePopupMedias();
// });



// GLIGHTBOX - Configuration
document.addEventListener('DOMContentLoaded', function() {
  function initGLightbox() {
    if (typeof GLightbox === 'undefined') {
      setTimeout(initGLightbox, 100);
      return;
    }

    // Cas galerie bloc (4 images affichées + galerie complète via mmProductGallery)
    if (window.mmProductGallery && window.mmProductGallery.length > 0) {
      const lightbox = GLightbox({
        elements: window.mmProductGallery,
        touchNavigation: true,
        loop: true,
        openEffect: "fade",
        closeEffect: "fade"
      });

      document.querySelectorAll('.mm-media-bloc-trigger').forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.preventDefault();
          const index = parseInt(el.getAttribute('data-index'), 10) || 0;
          lightbox.openAt(index);
        });
      });

      // Thumbnail desktop extra images
      const extraThumbsEl = document.querySelector('#mm-extra-thumbnails-desktop');
      if (extraThumbsEl && typeof Splide !== 'undefined') {
        new Splide(extraThumbsEl, {
          type: 'slide',
          perPage: 4,
          gap: 8,
          pagination: false,
          arrows: true,
          direction: 'ltr',
          width: '100%',
        }).mount();
      }

      document.querySelectorAll('.mm-extra-thumb-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const index = parseInt(btn.getAttribute('data-index'), 10) || 0;
          lightbox.openAt(index);
        });
      });
    } else {
      // Cas slider (splide) — sélecteur classique
      GLightbox({
        selector: '.glightbox[data-gallery="gallery1"]',
        touchNavigation: true,
        loop: true,
        openEffect: "fade",
        closeEffect: "fade"
      });
    }
  }

  initGLightbox();
});




class VariantSelector extends HTMLElement {
  constructor() {
      super();
      this.cached = {};
      this.container = this.closest("#product-form");
      this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
      this.getSelectedOptions();
      this.getSelectedVariant();

      if (this.currentVariant) {
          this.updateURL();
          this.variantFetch();
      }

      window.addEventListener('scroll', function(e) {
        derniere_position_de_scroll_connue = window.scrollY;

        if (!ticking) {
          window.requestAnimationFrame(function() {
            mmCtaSticky(derniere_position_de_scroll_connue);
            ticking = false;
          });
        }
      });


  }

  getSelectedOptions() {
      this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
  }

  getVariantJSON() {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
  }

  getSelectedVariant() {
      this.currentVariant = this.getVariantJSON().find((variant) => {
          const findings = !variant.options
              .map((option, index) => {
                  return this.options[index] === option;
              })
              .includes(false);

          if (findings) return variant;
      });
  }

  updateURL() {
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  variantFetch() {
      var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

      if (this.cached[variantUrl]) {
          this.renderVariantInfo(this.cached[variantUrl]);
          return;
      }

      fetch(variantUrl)
          .then((response) => response.text())
          .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, "text/html");
              this.cached[variantUrl] = html;
              this.renderVariantInfo(html);
          })
          .catch((e) => {
              console.error(e);
          });
  }

  renderVariantInfo(html) {
      this.updateElementOuter("#product_id", html);
      this.updateElementOuter(".mm-price", html);
      this.updateElementOuter(".mm-product-price-total", html);
      this.updateElementOuter(".mm-product-form-variant-option", html);
      this.updateElementOuter("#mm-converter input", html);
      this.updateElementOuter(".mm-cta-sticky", html);
  }

  /**
   *
   * @param {string} selector
   * @param {HtmlElement} html
   */
  updateElement(selector, html) {
      const destination = this.container.querySelector(selector);
      const source = html.querySelector(selector);
      if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateElementOuter(selector, html) {
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);
    if (source && destination) {
        // Vérifiez si l'élément à mettre à jour est le CTA
        if (selector === ".mm-cta-sticky") {
            destination.innerHTML = source.innerHTML;
            destination.classList.add('mm-cta-sticky');
        } else {
            destination.outerHTML = source.outerHTML;
        }
    }
}
}
customElements.define("variant-selector", VariantSelector);
